// SBU and Track mapping from Excel file
export const GROUP_MAPPING = {
  "SN BusService Oracle ASCP Monitoring": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle EDI Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle INV Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle Logistics Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle MFG Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle OM Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle OTC Functional": { sbu: "Application", track: "R12 Finance" },
  "SN BusService Oracle PO Functional": { sbu: "Application", track: "R12 ISC" },
  "SN BusService Oracle PTP Functional": { sbu: "Application", track: "R12 Finance" },
  "SN BUSSERVICE ORACLE RTR Functional": { sbu: "Application", track: "R12 Finance" },
  "SN BusService Oracle SVC Functional": { sbu: "Application", track: "R12 ISC" },
  "SN-GBL-Tier 2-EXApps ESC (My HR Support)": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Comp (PeopleFluent)": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Hire (Taleo)": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps My Legal Workcenter": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps PeopleSoft": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps Talent Mgmt Sys (TMS)": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps TeamConnect": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support promotion claim Center": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support BOM Lookup": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support FRACAS Support": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support IT HVAC Parts and Supply Solutions": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support NA Maxload": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support P21 Technical": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support PBS Deployment": { sbu: "Application", track: "RES, TK" },
  "SN APPl Support RS BP Apps": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support RS eBiz Apps": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support RS IT Warehouse Applications": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support RS Mendix": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support Ansira Co-Op Program": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support RS MES Applications": { sbu: "Application", track: "MES" },
  "SN Appl Support RS Sales and Margin Warehouse (SMW)": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support RS UPDS Order Fulfilment Team": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support SPIM DB": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support iService Access": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support MENDIX TRANSPORT AMERICAS": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support Test Request Process": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support TK iServiceDP Apps": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support L1.5 Smart ops Team": { sbu: "Application", track: "Tools" },
  "SN Appl Support HP Quality Center": { sbu: "Application", track: "Tools" },
  "SN Appl Support DFSD ANZ": { sbu: "Application", track: "MES" },
  "SN Appl Support Ent Apps Mendix": { sbu: "Application", track: "Customer Experience (CX)" },
  "SN-GBL-Tier 3-EXApps PeopleSoft": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps DSD Reporting": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps PhenomCRM Support": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support AWS Middleware Operations": { sbu: "Application", track: "Integration & Middleware" },
  "SN Appl Support Apriso RSHVAC": { sbu: "Application", track: "RES" },
  "SN Appl Support Dist Trailor Tracking Mendix": { sbu: "Application", track: "Customer Experience (CX)" },
  "SN-GBL-Tier 3-EXApps UKG Dimensions": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 2-EXApps UKG Dimensions": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support Gigaton Analytics": { sbu: "Application", track: "Data & Analytics" },
  "SN Appl Support RADAR Product Team": { sbu: "Application", track: "Data & Analytics" },
  "SN Appl Support Tableau License": { sbu: "Application", track: "Data & Analytics" },
  "SN Appl Support Alteryx License": { sbu: "Application", track: "Data & Analytics" },
  "SN Appl Support LATAM JOB SCORING": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support Lotus Notes": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support Service Agreement Renewal Task Board": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 3-EXApps PS HRMS Integrations": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN-GBL-Tier 3-EXApps TCC_Taleo": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support India HR Application": { sbu: "Application", track: "Employee Experience (EX)" },
  "SN Appl Support Controls Self-Assessment (CSA) Tool": { sbu: "Application", track: "L1.5" },
  "SN Appl Support Ultriva": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support Demantra": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support EOT Service": { sbu: "Application", track: "CHVAC Americas" },
  "SN Appl Support Intl Sales Tools Spectrum": { sbu: "Application", track: "CHVAC Americas" },
  "SN Appl Support VO": { sbu: "Application", track: "CHVAC Americas" },
  "SN Appl Support CS Field Service Tools Support": { sbu: "Application", track: "CHVAC Americas" },
  "SN Appl Support CRM Development": { sbu: "Application", track: "Customer Experience (CX)" },
  "SN Appl Support ProdAndTechSuptContactForm": { sbu: "Application", track: "CHVAC Americas" },
  "SN Appl Support EDH": { sbu: "Application", track: "Data & Analytics" },
  "SN-GBL-Tier 2-EXApps India E-Apps": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support P21 Mexico": { sbu: "Application", track: "RES, TK" },
  "SN Appl Support Evolven": { sbu: "Infrastructure", track: "Tools" },
  "SN Wipro Service Desk RDS": { sbu: "Infrastructure", track: "Service Desk" },
  "SN IT Security Firewall": { sbu: "Infrastructure", track: "Security" },
  "SN Knowledge Admin": { sbu: "Infrastructure", track: "ITSM" },
  "SN Appl Support Access Security": { sbu: "Infrastructure", track: "Security" },
  "SN Orion SolarWinds Monitoring": { sbu: "Infrastructure", track: "Hosting" },
  "SN Wipro Service Desk Service Not Listed": { sbu: "Infrastructure", track: "Service Desk" },
  "SN Appl Support Windows 365 (Windows App) Group": { sbu: "Infrastructure", track: "EUC" },
  "SN Appl Support Tanium": { sbu: "Infrastructure", track: "wintel" },
  "SN DBA-UNKNOWN": { sbu: "Infrastructure", track: "Database" },
  "SN Network Global Voice": { sbu: "Infrastructure", track: "NW Voice" },
  "SN BusService Support Teams Phone Service": { sbu: "Infrastructure", track: "NW Voice" },
  "SN Appl Support Company Portal": { sbu: "Infrastructure", track: "EUC" }
};

// Live mapping that starts as the hardcoded fallback, updated from CSV API
let liveGroupMapping = { ...GROUP_MAPPING };

// Load group mapping from CSV API endpoint
export const loadGroupMappingFromCSV = async () => {
  try {
    const baseUrl = window.location.hostname === 'localhost'
      ? 'http://localhost:8080'
      : '';
    const response = await fetch(`${baseUrl}/api/group-mapping`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const result = await response.json();
    if (result.success && Array.isArray(result.data) && result.data.length > 0) {
      const newMapping = {};
      result.data.forEach(row => {
        if (row.assignmentGroup) {
          newMapping[row.assignmentGroup] = { sbu: row.sbu || 'Others', track: row.track || 'Others' };
        }
      });
      liveGroupMapping = newMapping;
      console.log(`Group mapping loaded from CSV: ${result.data.length} entries`);
      return { success: true, count: result.data.length };
    }
    return { success: false, message: 'No data returned from API, using fallback' };
  } catch (error) {
    console.warn('Failed to load group mapping from CSV, using hardcoded fallback:', error.message);
    return { success: false, message: error.message };
  }
};

// Upload a new CSV file to update the mapping
export const uploadGroupMappingCSV = async (file) => {
  try {
    const baseUrl = window.location.hostname === 'localhost'
      ? 'http://localhost:8080'
      : '';
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${baseUrl}/api/group-mapping/upload`, {
      method: 'POST',
      body: formData
    });
    const result = await response.json();
    if (result.success) {
      // Reload the mapping after successful upload
      await loadGroupMappingFromCSV();
    }
    return result;
  } catch (error) {
    console.error('Failed to upload group mapping CSV:', error);
    return { success: false, error: error.message };
  }
};

// Download the current CSV file
export const downloadGroupMappingCSV = () => {
  const baseUrl = window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : '';
  window.open(`${baseUrl}/api/group-mapping/download`, '_blank');
};

// Helper function to get mapping for a group - uses live mapping
export const getGroupMapping = (groupName) => {
  return liveGroupMapping[groupName] || GROUP_MAPPING[groupName] || { sbu: "Others", track: "Others" };
};

// Get all unique SBUs - uses live mapping
export const getAllSBUs = () => {
  const sbus = [...new Set(Object.values(liveGroupMapping).map(m => m.sbu))];
  if (!sbus.includes('Others')) sbus.push('Others');
  return sbus.sort();
};

// Get all unique Tracks - uses live mapping
export const getAllTracks = () => {
  const tracks = [...new Set(Object.values(liveGroupMapping).map(m => m.track))];
  if (!tracks.includes('Others')) tracks.push('Others');
  return tracks.sort();
};

// Get tracks for a specific SBU
export const getTracksForSBU = (sbu) => {
  const tracks = Object.values(liveGroupMapping)
    .filter(m => m.sbu === sbu)
    .map(m => m.track);
  return [...new Set(tracks)].sort();
};

// Get assignment groups for a specific track
export const getGroupsForTrack = (track) => {
  return Object.entries(liveGroupMapping)
    .filter(([_, mapping]) => mapping.track === track)
    .map(([groupName, _]) => groupName);
};

// Get assignment groups for a specific SBU
export const getGroupsForSBU = (sbu) => {
  return Object.entries(liveGroupMapping)
    .filter(([_, mapping]) => mapping.sbu === sbu)
    .map(([groupName, _]) => groupName);
};
